export const formatLocalDateTime = (value, options = {}) => {
  if (!value) {
    return "-";
  }

  return new Date(value).toLocaleString(undefined, options);
};

export const formatLocalDate = (value, options = {}) => {
  if (!value) {
    return "-";
  }

  return new Date(value).toLocaleDateString(undefined, options);
};

export const formatLocalTime = (value, options = {}) => {
  if (!value) {
    return "-";
  }

  return new Date(value).toLocaleTimeString(undefined, options);
};
